import { render, staticRenderFns } from "./funnel-stage-leads.vue?vue&type=template&id=228c4924"
import script from "./funnel-stage-leads.vue?vue&type=script&lang=ts"
export * from "./funnel-stage-leads.vue?vue&type=script&lang=ts"
import style0 from "./funnel-stage-leads.vue?vue&type=style&index=0&id=228c4924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports